import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon } from 'lucide-react';
import { sections } from '../data/sections';
export function SectionDirectory() {
  return <section className="bg-platinum-100 py-20 lg:py-24" aria-labelledby="directory-heading" data-id="element-67" data-mp="10irtfy6yuby6">
      <div className="mx-auto w-full max-w-7xl px-6 lg:px-10" data-id="element-68" data-mp="vs31khrdjcyi">
        <div className="max-w-3xl" data-id="element-69" data-mp="vqi2ceu475ub">
          <p className="font-sans text-xs font-semibold uppercase tracking-[0.18em] text-gold-600" data-id="element-70" data-mp="1agz45zanvxrq">
            Site Directory
          </p>
          <h2 id="directory-heading" className="mt-3 font-display text-3xl font-bold leading-tight tracking-tightest text-navy-900 sm:text-4xl" data-id="element-71" data-mp="15gtcij4e6b9n">
            Ten sections, each with a single purpose
          </h2>
          <p className="mt-4 font-sans text-base leading-relaxed text-charcoal-600 lg:text-lg" data-id="element-72" data-mp="1fe7mbzvt81sz">
            Every part of this portfolio is a distinct section. What each one contains is stated
            below so directors and stakeholders can go straight to what they need.
          </p>
        </div>

        <ol className="mt-12 grid grid-cols-1 gap-px border border-platinum-200 bg-platinum-200 md:grid-cols-2" data-id="element-73" data-mp="1uygi4ojxonva">
          {sections.map(section => <li key={section.path} className="bg-white" data-id="element-74" data-mp="1zwrub5xpbago">
              <Link to={section.path} className="group flex h-full flex-col p-8 transition-colors duration-150 ease-out hover:bg-platinum-100 focus-visible:outline focus-visible:outline-2 focus-visible:-outline-offset-2 focus-visible:outline-gold-600 lg:p-10" data-id="element-75" data-mp="24o04i46uuzuw">
                <div className="flex items-start justify-between gap-6" data-id="element-76" data-mp="2inj60e55vcy8">
                  <span className="font-display text-sm font-bold tracking-[0.12em] text-gold-600" data-id="element-77" data-mp="2nn47av7szxe4">
                    {section.number}
                  </span>
                  <ArrowRightIcon className="h-5 w-5 shrink-0 text-platinum-300 transition-all duration-200 ease-smooth group-hover:translate-x-1 group-hover:text-gold-600" aria-hidden="true" data-id="element-78" data-mp="obkzwl25ex6k" />
                </div>
                <h3 className="mt-4 font-display text-xl font-bold leading-snug tracking-tight text-navy-900" data-id="element-79" data-mp="h7v9p8f1z8xw">
                  {section.name}
                </h3>
                <p className="mt-3 font-sans text-sm leading-relaxed text-charcoal-600" data-id="element-80" data-mp="q7i0z1e2iyd8">
                  {section.summary}
                </p>
                <ul className="mt-auto flex flex-wrap gap-2 pt-6" data-id="element-81" data-mp="145yhfk1qg38k">
                  {section.contains.map(item => <li key={item} className="whitespace-nowrap border border-platinum-200 bg-platinum-100 px-2.5 py-1 font-sans text-xs font-semibold text-charcoal-700" data-id="element-82" data-mp="105fofmo3sr4s">
                      {item}
                    </li>)}
                </ul>
              </Link>
            </li>)}
        </ol>
      </div>
    </section>;
}